'use client'
import * as React from 'react'
import { LazyMotion, domAnimation, AnimatePresence, m } from 'framer-motion'
import { useHasAllAccessQuery } from '@repo/cf-user/hooks/use-user-data'
import { tw } from 'utils/classnames'

interface FreeTrialBannerSectionProps extends React.PropsWithChildren {
  children: React.ReactNode
}

export function FreeTrialBannerSection({ children }: FreeTrialBannerSectionProps) {
  const { data: userHasAllAccess, isPending } = useHasAllAccessQuery()
  const [showFreeTrialBanner, setShowFreeTrialBanner] = React.useState(false)

  React.useEffect(() => {
    // oxlint-disable-next-line unicorn/prefer-query-selector
    const element = document.getElementById('enable-bottom-floating-banner')
    if (!element) {
      return
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry) {
        return
      }
      setShowFreeTrialBanner(!entry.isIntersecting && entry.boundingClientRect.top <= 0)
    })

    observer.observe(element)
    return () => observer.disconnect()
  }, [])
  const showBanner = !userHasAllAccess && !isPending

  const animationSettings = { y: '0%' }

  return (
    <section className="m-auto flex w-full justify-center">
      <LazyMotion features={domAnimation}>
        <AnimatePresence>
          {showBanner && showFreeTrialBanner ? (
            <m.div
              animate={animationSettings}
              initial={{ y: '100%' }}
              exit={{ y: '100%' }}
              transition={{ duration: 0.3, ease: 'easeInOut' }}
              className={tw('fixed bottom-0 z-10 m-auto flex w-full')}
            >
              {children}
            </m.div>
          ) : null}
        </AnimatePresence>
      </LazyMotion>
    </section>
  )
}
